import { Button, Drawer, Stack, Typography } from '@mui/material';
import InputPasswordComponent from 'components/input-password/InputPasswordComponent';
import { useSnackbar } from 'components/snackbar/SnackbarContext';
import { changePassword } from 'features/account/service/AccountProfileService';
import { useState } from 'react';

const AccountChangePasswordSidebarComponent = ({ isOpen, onBack, onClose }) => {
  const [confirmPassword, setConfirmPassword] = useState('');
  const [currentPassword, setCurrentPassword] = useState('');
  const { setMessage } = useSnackbar()
  const [newPassword, setNewPassword] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const submit = async () => {
    setSubmitted(true);

    if (!currentPassword || !newPassword || !confirmPassword) {
      setMessage({
        title: 'Failed to change password',
        desc: 'Please fill in all fields',
        type: 'error',
      });

      return;
    }

    if (newPassword !== confirmPassword) {
      setMessage({
        title: 'Failed to change password',
        desc: 'Mismatch new password',
        type: 'error',
      });
      return;
    }

    const data = {
      current_password: currentPassword,
      new_password: newPassword,
    };

    const response = await changePassword(data);
    if (response?.info?.title === "success") {
      setMessage({
        title: "Success",
        desc: "Password updated",
        type: "success",
      });
      setConfirmPassword('');
      setCurrentPassword('');
      setNewPassword('');
      setSubmitted(false);
      onBack();
    } else {
      setMessage({
        title: "Failed",
        desc: response,
        type: 'error',
      });
    }
  };

  return (
    <Drawer
      className='account-profile-drawer'
      anchor='right'
      open={isOpen}
    >
      <Stack className="header" direction="row" justifyContent="space-between" alignItems="center">
          <img alt='close-profile-icon' className='cursor-pointer' src='/images/sidebar/sidebar-back.svg' onClick={onBack} /> 
          <p className='account-profile-title'>Change Password</p>
          <img alt='close-profile-icon' className='cursor-pointer' src='/images/close-profile-icon.svg' onClick={onClose} /> 
      </Stack>
      <Stack className="container" spacing={3}>
        <Stack spacing={1}>
          <Typography fontSize={12}>Current Password</Typography>
          <InputPasswordComponent
            error={submitted && !currentPassword}
            name='current-password'
            value={currentPassword}
            onChange={setCurrentPassword}
            placeholder="Current password"
          />
        </Stack>
        <Stack spacing={1}>
        <Typography fontSize={12}>New Password</Typography>
          <InputPasswordComponent
            error={submitted && !newPassword}
            name='new-password'
            value={newPassword}
            onChange={setNewPassword}
            placeholder="New password"
          />
        </Stack>
        <Stack spacing={1}>
          <Typography fontSize={12}>Confirm New Password</Typography>
          <InputPasswordComponent
            error={submitted && !confirmPassword}
            name='confirm-password'
            value={confirmPassword}
            onChange={setConfirmPassword}
            placeholder="Confirm new password"
          />
        </Stack>
        <Stack spacing={2} direction="row" justifyContent="flex-end" width="100%">
          <Button
            color='secondary'
            onClick={onBack}
            variant='outlined'
          >
            <Typography fontSize={12}>Cancel</Typography>
          </Button>
          <Button onClick={submit} variant='contained' className='!bg-[#556FB5]'> 
            <Typography fontSize={12}>Save Changes</Typography>
          </Button>
        </Stack>
      </Stack>
    </Drawer>
  );
};

export default AccountChangePasswordSidebarComponent;
